
import axios from "axios";
import { getUrl } from "../../MIS/Global";


// Axios instance for making API calls (you can configure it as needed)
const apiClient = axios.create({
  baseURL: getUrl(),  // Replace with your API base URL
  headers: {
    "Content-Type": "application/json",
  },
});

// Fetch all items (GET request)
export const userMenu_fetchItems = async (data) => {  
  const queryParams = new URLSearchParams(data).toString();
  const response = await apiClient.get(`mainproduct/?${queryParams}`);  
  return response?.data;
};
 
